module.exports = __webpack_public_path__ + "img/03.7d1f3e89.jpg";